import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, combineLatest, debounceTime, map, switchMap } from 'rxjs';

import { SolutionSpace } from 'src/app/models/solution';
import { DatalogService } from 'src/app/services/api/datalog.service';
import { DateInterval } from 'src/app/models/date.model';
import { ComponentInsightsComponent } from '../../shared/component-insights/component-insights';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-zx-component-incidents',
  templateUrl: './zx-component-insights.html',
  styleUrls: ['./zx-component-insights.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ComponentInsightsComponent, AsyncPipe],
})
export class ZxComponentInsightsComponent {
  measurementHumidityDateInterval$ = new BehaviorSubject({
    start: new Date(Date.now() - 12096e5),
    end: new Date(),
  });

  measurementNSEDateInterval$ = new BehaviorSubject({
    start: new Date(Date.now() - 12096e5),
    end: new Date(),
  });

  solutionSpace$ = this.route.params.pipe(
    map((el) => (el.utilorhumid === 'humidity' ? SolutionSpace.Humidity : SolutionSpace.Utilization))
  );

  componentId$ = this.route.params.pipe(map((el) => el.id as string));

  datalogsHumidity$ = combineLatest([this.componentId$, this.measurementHumidityDateInterval$]).pipe(
    debounceTime(500),
    switchMap(([componentId, dateInterval]) =>
      this.datalogService.getComponentDatalog(componentId, dateInterval.start, dateInterval.end)
    )
  );

  datalogsNSE$ = combineLatest([this.componentId$, this.measurementNSEDateInterval$]).pipe(
    debounceTime(500),
    switchMap(([componentId, dateInterval]) =>
      this.datalogService.getComponentDatalog(componentId, dateInterval.start, dateInterval.end)
    )
  );

  constructor(private route: ActivatedRoute, private datalogService: DatalogService) {}

  updateDateRangeNSE(newDateRange: DateInterval) {
    this.measurementNSEDateInterval$.next({ start: newDateRange.start, end: newDateRange.end });
  }

  updateDateRangeHumidity(newDateRange: DateInterval) {
    this.measurementHumidityDateInterval$.next({ start: newDateRange.start, end: newDateRange.end });
  }
}
